<!--
 * @Description: 新增延期时间弹窗
 * @Date: 2025-09-12 17:56:29
-->
<template>
  <BaseDialog
    width="550px"
    title="新增延期时间"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <BaseTextContent>
      <BaseForm ref="formRef" label-position="top" :model="formData">
        <BaseFormItem
          label="服务有效期"
          prop="expira"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        >
          <BaseDatePicker
            style="width: 100%"
            type="daterange"
            placeholder="请选择"
            validate-event
            :disabledDate="disabledDate"
            v-model="formData.expira"
          />
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="onCancel">取消</BaseButton>
      <BaseButton type="primary" :click="onConfirm">保存</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseDatePicker
} from 'xrk-components';
import { updateExpiraAt } from '../../data-source/apis';
import { formatter } from '@/utils';
import { useDateFormat } from '@vueuse/core';

const emits = defineEmits(['success']);
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    id: number;
    registerAt: string; // 企业注册时间。如果服务有效期(expiraEnd)无值则以企业注册时间为默认时间：registerAt ~ registerAt+365-1
    expiraEnd: string; // 当前已生效的服务有效期结束
    historyExpiraDateList: Array<{ startAt: string; endAt: string }>; // 延期日期集合，最后一个一定是最大时间
  }>(),
  {}
);

const formRef = ref();
const formData = ref({
  expira:
    !props.expiraEnd && props.registerAt
      ? [
          props.registerAt,
          useDateFormat(
            new Date(
              new Date(props.registerAt).getTime() +
                (365 - 1) * 24 * 60 * 60 * 1000
            ),
            'YYYY-MM-DD'
          ).value
        ]
      : []
});

const disabledDate = date => {
  // 未设置过则不限制
  if (!props.expiraEnd) {
    return false;
  }
  const historyExpiraDateList = props.historyExpiraDateList;
  const curTime = date.getTime();
  // 可选范围为 大于最大日期的结束时间
  const lastTime = new Date(
    historyExpiraDateList?.length
      ? historyExpiraDateList[0].endAt
      : props.expiraEnd
  ).getTime();
  return curTime <= lastTime;
};
const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  await formRef.value.validate();
  await updateExpiraAt({
    id: props.id,
    expiraStart: formatter.date(formData.value.expira[0], 'YYYY-MM-DD'),
    expiraEnd: formatter.date(formData.value.expira[1], 'YYYY-MM-DD')
  });
  XrkMessage.success('操作成功');
  emits('success');
  onCancel();
};
</script>
